module.exports = __webpack_public_path__ + "img/face-pouting.d9806d74.svg";